import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceFormulaScheme } from './service-formula-scheme.model';
import * as ServiceFormulaSchemeActions from './service-formula-scheme.actions';

export const serviceFormulaSchemesFeatureKey = 'serviceFormulaSchemes';

export interface State extends EntityState<ServiceFormulaScheme> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceFormulaScheme> = createEntityAdapter<ServiceFormulaScheme>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceFormulaSchemeActions.addServiceFormulaScheme,
    (state, action) => adapter.addOne(action.serviceFormulaScheme, state)
  ),
  on(ServiceFormulaSchemeActions.upsertServiceFormulaScheme,
    (state, action) => adapter.upsertOne(action.serviceFormulaScheme, state)
  ),
  on(ServiceFormulaSchemeActions.addServiceFormulaSchemes,
    (state, action) => adapter.addMany(action.serviceFormulaSchemes, state)
  ),
  on(ServiceFormulaSchemeActions.upsertServiceFormulaSchemes,
    (state, action) => adapter.upsertMany(action.serviceFormulaSchemes, state)
  ),
  on(ServiceFormulaSchemeActions.updateServiceFormulaScheme,
    (state, action) => adapter.updateOne(action.serviceFormulaScheme, state)
  ),
  on(ServiceFormulaSchemeActions.updateServiceFormulaSchemes,
    (state, action) => adapter.updateMany(action.serviceFormulaSchemes, state)
  ),
  on(ServiceFormulaSchemeActions.deleteServiceFormulaScheme,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceFormulaSchemeActions.deleteServiceFormulaSchemes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceFormulaSchemeActions.loadServiceFormulaSchemes,
    (state, action) => adapter.setAll(action.serviceFormulaSchemes, state)
  ),
  on(ServiceFormulaSchemeActions.clearServiceFormulaSchemes,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
